







































































































































































































































































































































import { Component, namespace, mixins } from 'nuxt-property-decorator'
import MixinCart from '~/assets/mixins/cart'

const siteStore = namespace('site')

@Component
export default class ComponentOrderCart extends mixins(MixinCart) {
  @siteStore.Getter('getLayoutHeaderNumber') readonly layoutHeaderNumber!: 5 | 7

  private fixedHeaderNumbers = [5, 7]

  private get getFixedHeaderClasses() {
    const isFixed =
      this.layoutHeaderNumber &&
      this.fixedHeaderNumbers.includes(this.layoutHeaderNumber)

    return {
      [this.$style.fixedHeader]: isFixed,
      [this.$style['fixedHeader__' + this.layoutHeaderNumber]]: isFixed,
    }
  }
}
